<!--
 * @Description:跟进记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-09 17:25:43
 * @LastEditors: cxh
-->
<template>
  <cos-table :columns="columns" @fetch="fetch" :tableId="tableIdByPath('business')" @mask="showMask" ref="tableRef" rowKey="id">
    <template #bodyCell="{ column, record, text }">
      <template v-if="column.dataIndex === 'saleChanceName'">
        <router-link :to="'/lbu/business/view?id=' + record.id" :title="record.saleChanceNameByTxt">
          <BusinessName
            v-if="text"
            appId="cos_lbu"
            v-model:value="record.saleChanceName"
            v-model:label="record.saleChanceNameByTxt"
          />
          <p v-else>--</p>
        </router-link>
      </template>
      <template v-if="column.dataIndex === 'competitors'">
        {{ competitorFormat(text) || '--' }}
      </template>
      <template v-if="column.dataIndex === 'requiredCountry'">
        <ChannelText appId="cos_lbu" paramCode="lbu_demand_country" :value="text" />
      </template>
      <template v-if="column.dataIndex === 'product'">
        <ChannelText appId="cos_lbu" paramCode="lbu_products" :value="text" />
      </template>
      <template v-if="column.type === 'money'">
        <p>{{ formatThousandSeparator(text)}}</p>
      </template>
      <template v-if="column.dataIndex === 'action'">
        <MoreButton>
          <SellerButton
            :workCode="record.dutyBy"
            type="link"
            @click="handleEdit(record)"
            v-permission="permissionPage?.edit"
            >编辑</SellerButton
          >
          <a-button type="link" @click="handleDelete(record)" v-permission="permissionPage?.del">删除</a-button>
        </MoreButton>
      </template>
    </template>
  </cos-table>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { businessList, businessDelete, businessDetails } from '@/api/yuntuSales/chanceManage'
import dataConfig from '@/views/yuntuSales/commonEnum/dataConfig'
import BusinessName from '@/components/BusinessName/index.vue'
import Modal from '@/hooks/modalType'
import { useRoute, useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { BusinessListItem } from '@/typings/api/chanceManage'
import { tableIdByPath } from '@/utils'
import { ParamCodeItem } from '@/typings/common'
import formatThousandSeparator from '@/utils/format'
import { listByParamCodes } from '@/api/common'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
const router = useRouter()
const route = useRoute()
const tableRef = ref()
// const loading = ref(false)
defineProps({
  edit: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  returnName: {
    type: String
  }
})
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [], // 出货渠道（云途产品）
  lbu_logistics_service_provider: [] // 物流服务商
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products', 'lbu_logistics_service_provider']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
})
const fetch = (queryForm: object, callBack: (res: any) => void) => {
  businessList({
    arkCode: route.query.arkCode as string,
    saleChanceRefId: route.query.cosId as string,
    ...queryForm
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

// 添加
// const handleAdd = () => {
//   router.push({
//     path: '/lbu/business/add',
//     query: {
//       saleChanceRefId: route.query.cosId,
//       returnPath: route.fullPath
//     }
//   })
// }
// 编辑
const handleEdit = (row: BusinessListItem) => {
  router.push({
    path: '/lbu/business/edit',
    query: {
      id: row.id
    }
  })
}
// 删除
const handleDelete = (row: BusinessListItem) => {
  Modal.delete({
    name: row.saleChanceNameByTxt,
    onOk() {
      businessDelete({ id: row.id }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
const columns = ref([
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left' },
  { title: '客户名称', dataIndex: 'customerName' },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '目的地国家', dataIndex: 'requiredCountry' },
  { title: '云途产品', dataIndex: 'product', width: 150 },
  { title: 'OPR金额', dataIndex: 'planSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OPR票数', dataIndex: 'mau', type: 'money', sorter: true },
  { title: 'OCR金额', dataIndex: 'committedSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OCR票数', dataIndex: 'committedShipment', type: 'money', sorter: true },
  { title: '商机创建时间', dataIndex: 'createTime', width: 190 },
  { title: '商机状态', dataIndex: 'status', dicData: dataConfig.businessStatusEnum },
  { title: '竞争对手', dataIndex: 'competitors' },
  { title: '剩余变更时间', dataIndex: 'remanentFollowDays', width: 200, sorter: true },
  { title: '最新跟进时间', dataIndex: 'latestFollowTime', width: 190, sorter: true },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', fixed: 'right' }
])
/**
 * 竞争对手序列化
 * @param arr 对手数组
 */
const competitorFormat = (arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const listEnum = paramCodeData.value.lbu_logistics_service_provider
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}
</script>
<script lang="ts">
export default { name: 'OperationLog' }
</script>
<style lang="scss" scoped></style>
